import { createClient, SupabaseClient } from '@supabase/supabase-js';

// Ensure environment variables are loaded
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL?.trim();
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim();

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
    throw new Error('Missing required Supabase environment variables');
}

// Validate URL format
if (!SUPABASE_URL.startsWith('https://')) {
    throw new Error('VITE_SUPABASE_URL must start with https://');
}

if (!SUPABASE_URL.includes('.supabase.co')) {
    throw new Error('VITE_SUPABASE_URL must be a valid Supabase URL');
}

let supabase: SupabaseClient | null = null;

const getSupabase = () => {
    if (!supabase) {
        try {
            supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
                auth: {
                    persistSession: true,
                    autoRefreshToken: true,
                    detectSessionInUrl: true,
                    storageKey: 'carelms-supabase-auth',
                    storage: window.localStorage,
                    flowType: 'pkce'
                },
                global: {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Client-Info': 'carelms-web'
                    }
                },
                db: {
                    schema: 'public'
                },
                realtime: {
                    params: {
                        eventsPerSecond: 10
                    }
                }
            });

            // Test connection with a simpler query
            supabase.auth.getSession()
                .then(({ data: { /* session */ }, error }) => {
                    if (error) {
                        console.error('Failed to connect to Supabase:', error.message);
                    }
                })
                .catch((err: Error) => {
                    console.error('Error testing Supabase connection:', err.message);
                });
        } catch (error) {
            console.error('Error initializing Supabase client:', error);
            throw error;
        }
    }
    return supabase;
};

export { getSupabase }; 